import { mergeAttributes, nodePasteRule } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { RecipientComponent } from '../../components/recipient/recipient-component';
import { RecipientSelector } from '../../components/recipient/recipient-selector';
import { matchers } from '../config/matchers';
import { Tag } from './tag';

export const matchQuery = matchers.recipient.possible;

export const Recipient = Tag.extend({
	name: 'recipient',
	addOptions() {
		return {
			...this.parent?.(),
			char: '@',
			component: RecipientSelector,
			debounceFetch: true,
			insertPrefixSpace: true,
			matchQuery,
			requireSelection: true,
		};
	},

	addPasteRules() {
		return [
			nodePasteRule({
				find: matchers.recipient.paste,
				type: this.type,
				getAttributes: (match) => {
					const text = match[0];
					return {
						id: text.startsWith('@') ? text.slice(1) : text,
					};
				},
			}),
		];
	},

	parseHTML() {
		return [
			{
				tag: `recipient[data-type="${this.options.tagName ?? this.name}"]`,
			},
		];
	},

	renderHTML({ node, HTMLAttributes }) {
		const recipientId = node.attrs.id ?? HTMLAttributes['data-id'];
		const label = recipientId ? `${this.options.char ?? '@'}${recipientId}` : '';

		return ['recipient', mergeAttributes({ 'data-type': this.options.tagName ?? this.name }, HTMLAttributes), label];
	},

	addNodeView() {
		return ReactNodeViewRenderer(RecipientComponent);
	},
});
